import { ReactElement } from "react"
import styled from "styled-components"
import { PromoVideoProps } from "../types"

export default function PromoVideo({
  videoSrc,
  posterSrc,
  title = "Promo Video",
}: PromoVideoProps): ReactElement {
  return (
    <VideoWrapper>
      <StyledVideo
        controls
        preload="metadata"
        poster={posterSrc}
        controlsList="nodownload"
        title={title}>
        <source src={videoSrc} type="video/mp4" />
        <p>
          Your browser doesn't support HTML5 video.
          <a href={videoSrc}>Download the video</a> instead.
        </p>
      </StyledVideo>
    </VideoWrapper>
  )
}

const VideoWrapper = styled.div`
  width: 100%;
  position: relative;
`

const StyledVideo = styled.video`
  width: 100%;
  height: auto;
  border-radius: 1rem;
  box-shadow: 0 0 0 0.2rem var(--white);
  background-color: #000;

  /* Match the image styling exactly */
  max-width: 100%;
  display: block;
`
